import React from 'react';
import {View} from 'react-native';
import {PasswordCreationForm} from '../../../desktop/components/passwordCreationForm/PasswordCreationForm';
import {useNavigation} from '@react-navigation/native';

export const MobilePasswordCreation: React.FC<{onFormSubmitted?: () => void}> = ({onFormSubmitted}) => {
  const nav = useNavigation();
  const handlePasswordCreated = () => {
    nav.goBack();
    onFormSubmitted?.();
  };
  return (
    <View style={{flex: 1, padding: 16}}>
      <PasswordCreationForm onSubmit={handlePasswordCreated} />
    </View>
  );
};
